import React from "react";
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { setSortBy } from '../redux/search/search-slice';
import { setCurrentPage } from "../redux/settings/page-settings-slice";
import ResultsCount from "./ResultsCount";

export default function Sort() {
    const dispatch = useAppDispatch();

    return (
        <div className="performance-search-sort-container">
            <ResultsCount />
            <div className="performance-search-sort">
                <label htmlFor="sort-dropdown" className="h5-style"> Sort </label>
                <select
                    id="sort-dropdown"
                    className="performance-search-dropdown"
                    defaultValue={useAppSelector((state) => state.searchOptions.sortBy)}
                    disabled={useAppSelector((state) => state.pageSettings.isInMaintenanceMode)}
                    onChange={(e) => {
                        dispatch(setSortBy(e.target.value))
                        dispatch(setCurrentPage(1))
                    }
                }>
                    <option value="OperaTitle">By Opera</option>
                    <option value="ComposerName">By Composer</option>
                </select>
            </div>
        </div>

    );
}